import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const CourseCard = ({ title, description, category, duration, language, instructor, link, blogSlug }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      whileHover={{ y: -5 }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col"
    >
      <div className="p-6 flex-grow">
        <span className="inline-block px-3 py-1 text-sm font-semibold text-primary-600 bg-primary-100 rounded-full mb-2">
          {category}
        </span>
        <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{description}</p>
        
        <div className="flex flex-wrap gap-2 mb-4">
          <span className="text-sm bg-gray-100 px-2 py-1 rounded">{duration}</span>
          <span className="text-sm bg-gray-100 px-2 py-1 rounded">{language}</span>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          {t('common.instructor')}: {instructor}
        </p>

        {blogSlug && (
          <Link 
            to={`/blog/${blogSlug}`}
            className="text-primary-600 hover:text-primary-800 text-sm font-medium"
          >
            {t('common.relatedArticle')} →
          </Link>
        )}
      </div>

      <div className="p-4 border-t border-gray-100">
  {link ? (
    <Link
      to={link}
      className="block w-full text-center bg-primary-600 text-white py-2 px-4 rounded hover:bg-primary-700 transition-colors"
    >
      {t('common.learnMore')}
    </Link>
  ) : (
    <button
      disabled
      className="block w-full text-center bg-gray-300 text-gray-500 py-2 px-4 rounded cursor-not-allowed"
    >
      {t('common.learnMore')}
    </button>
  )}
</div>
    </motion.div>
  );
};

export default CourseCard;